module.exports = __webpack_public_path__ + "static/media/1.d0333da1.svg";